module.exports = __webpack_public_path__ + "img/img_channel_produce@3x.8b42674f.png";